import { GroupAdd, Pets, Star } from '@mui/icons-material'
import {
	darkRoyalBlue,
	lightPurple,
	ModuleActionVariant,
	ModuleIconVariant,
	orange,
	purple,
	white
} from '@wolfdanepug/common-react'

// welcome module configuration
const welcome = {
	title: 'Hi {name}',
	text: 'Welcome to your Wolf Dane Pug Dashboard. Here you can manage your subscription, payment methods, addresses and settings.',
	gap: 3,
	sx: {
		root: {
			background: {
				md: 'url(https://static.wixstatic.com/media/1b43b4_9212c93f6ad44fbb823b97d0f1ba53d0~mv2.jpg) no-repeat'
			},
			backgroundSize: 'cover',
			backgroundPosition: {
				xs: 'right bottom',
				md: 'right center'
			}
			// '&::before': {
			// 	content: '""',
			// 	position: 'absolute',
			// 	top: 0,
			// 	left: 0,
			// 	width: '100%',
			// 	height: '100%',
			// 	backgroundColor: 'rgba(255,255,255,.3)'
			// }
		},
		content: {
			minHeight: {
				xs: 200,
				md: 350
			},
			pt: {
				md: '125px'
			},
			pb: {
				xs: '125px',
				md: '0'
			},
			pr: {
				sm: '0',
				md: '55%'
			}
		},
		text: {
			color: '#757575'
		}
	}
}

// subscription module configuration
const subscription = {
	sx: {
		root: {
			backgroundColor: lightPurple
		}
	}
}

// gourmet points module configuration
const gourmetPoints = {
	text: 'Gourmet Points',
	color: purple,
	icon: Star,
	iconVariant: ModuleIconVariant.CONTAINED,
	showOverlay: true,
	// action: {
	// 	label: 'Learn more?',
	// 	link: '/rewards/gourmet-points',
	// 	variant: ModuleActionVariant.TEXT
	// },
	sx: {
		root: {
			// backgroundColor: purple
		},
		content: {
			pt: '125px'
		},
		title: {
			fontSize: '56px',
			fontWeight: 500,
			color: white
		},
		text: {
			color: white,
			fontSize: '28px',
			fontWeight: 500
		},
		action: {
			color: white,
			fontSize: '14px',
			// textDecorationColor: 'rgba(255, 255, 255, 0.5)'
			textDecoration: 'none'
		}
	}
}

// refer module configuration
const refer = {
	title: 'Refer a Friend',
	text: 'Get a $5.00 coupon towards your Gourmet Box, with each friend you refer.',
	color: darkRoyalBlue,
	icon: GroupAdd,
	showOverlay: true,
	iconVariant: ModuleIconVariant.CONTAINED,
	gap: 1,
	action: {
		label: 'Invite now!',
		fontSize: '14px',
		link: '',
		variant: ModuleActionVariant.BUTTON
	},
	sx: {
		content: {
			pt: '125px'
		},
		title: {
			fontSize: '28px',
			fontWeight: 500,
			color: white
		},
		text: {
			color: white,
			fontSize: '14px'
		},
		action: {
			color: white
		}
	}
}

// profile module configuration
const profile = {
	title: `Complete your pet's profile`,
	text: `Complete your pet's profile and receive $5.00 off their next Gourmet Box.`,
	color: orange,
	icon: Pets,
	iconVariant: ModuleIconVariant.CONTAINED,
	showOverlay: true,
	gap: 2,
	action: {
		label: 'Complete now!',
		link: '/pets',
		variant: ModuleActionVariant.BUTTON
	},
	sx: {
		content: {
			pt: '125px'
		},
		title: {
			fontSize: '28px',
			fontWeight: 500,
			color: white
		},
		text: {
			color: white,
			fontSize: '14px'
		},
		action: {
			color: white
		}
	}
}

// events module configuration
const events = {
	title: 'Meet up with Wolf Dane Pug',
	text: 'Upcoming Events',
	color: lightPurple,
	gap: 3,
	sx: {
		text: {
			fontSize: '20px',
			fontWeight: 500
		}
	}
}

export const enabled = [
	'welcome',
	'subscription',
	'gourmetPoints',
	// 'refer',
	// 'profile',
	'events'
]

export default {
	welcome,
	subscription,
	gourmetPoints,
	refer,
	profile,
	events
} as any
